/// <amd-module name="Build/Admin/Common/Actions/ServiceEndpointActions" />
import { Action } from "VSS/Reflux/Action";

import { AzureSubscription, ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

import { VirtualMachineScaleSet } from "Build/Admin/Common/Client/Contracts/DistributedTask/Azure";
import { StoreStatus } from "Build/Admin/Common/Constants";

export class ServiceEndpointActions {
    public azureSubscriptionsUpdated = new Action<AzureSubscription[]>();
    public azureSubscriptionsStatusUpdated = new Action<StoreStatus>();
    public serviceEndpointsUpdated = new Action<IServiceEndpointsUpdatePayload>();
    public serviceEndpointsStatusUpdated = new Action<StoreStatus>();
    public serviceEndpointAuthorized = new Action<ServiceEndpoint>();
    public virtualMachineScaleSetsUpdated = new Action<VirtualMachineScaleSet[]>();
    public virtualMachineScaleSetsErrorUpdated = new Action<string | undefined>();
    public virtualMachineScaleSetsStatusUpdated = new Action<StoreStatus>();
}

export interface IServiceEndpointsUpdatePayload {
    serviceEndpointScope: string;
    serviceEndpoints: ServiceEndpoint[];
}
